import classNames from 'classnames';

import { Link } from '@components/Link';
import { Svg } from '@components/Svg';

import { CmsColor, CmsInternalNavigationLink } from '@interfaces/common';

import styles from './WhereToBuyBadge.module.css';

interface WhereToBuyBadgeProps
	extends Omit<CmsInternalNavigationLink, '_key' | '_type'> {
	backgroundColor: Required<CmsColor>;
}

export const WhereToBuyBadge: React.VFC<WhereToBuyBadgeProps> = ({
	title,
	url,
	backgroundColor,
}) => {
	const colorH = Math.round(backgroundColor.hsl.h);
	const colorS = Math.round(100 * backgroundColor.hsl.s);
	const colorL = backgroundColor.hsl.l;
	const colorLDarker = Math.round(
		100 * (colorL - 0.1 >= 0 ? colorL - 0.1 : colorL)
	);
	const colorLLighter = Math.round(
		100 * (colorL + 0.1 <= 1 ? colorL + 0.1 : colorL)
	);
	const styleProperties = {
		'--background-color-darker': `hsl(${colorH}, ${colorS}%, ${colorLDarker}%)`,
		'--background-color-lighter': `hsl(${colorH}, ${colorS}%, ${colorLLighter}%)`,
	} as React.CSSProperties;

	return (
		<Link className={styles.badge} href={url} style={styleProperties}>
			<Svg aria-hidden="true" id="badge" />
			<span className={classNames(styles['badge-text'], 'fluid-font-t6-bold')}>
				{title}
			</span>
		</Link>
	);
};
